import React from 'react';
import {
  Select as MuiSelect,
  type SelectProps,
  type SelectChangeEvent,
} from '@mui/material';

export type { SelectProps, SelectChangeEvent };

export type SelectAtomProps = Omit<SelectProps, 'value' | 'onChange'> & {
  value: string | number;
  setValue: (value: string | number) => void;
};

export default function Select({
  value,
  setValue,
  size = 'small',
  fullWidth = true,
  ...rest
}: SelectAtomProps) {
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setValue(event.target.value as string | number);
  };

  return (
    <MuiSelect
      value={value}
      onChange={handleChange}
      size={size}
      fullWidth={fullWidth}
      {...rest}
    />
  );
}
